// API 설정
export const API_CONFIG = {
  // 요청 경로가 /api로 시작하므로 환경변수의 마지막 /api는 중복하지 않습니다.
  BASE_URL: (process.env.REACT_APP_API_URL || "http://localhost:3001")
    .replace(/\/+$/, "")
    .replace(/\/api$/, ""),
};

// 앱 설정 정보
export const APP_CONFIG = {
  // 앱 이름
  APP_NAME: "Lengsup Admin",

  // 앱 설명
  APP_DESCRIPTION: "Lengsup 관리자 페이지",
};

// 딥링크/스토어 설정 (환경 변수 기반)
export const DEEPLINK_CONFIG = {
  APP_SCHEME: process.env.REACT_APP_APP_SCHEME || "lengsup",
  INVITE_PATH: process.env.REACT_APP_INVITE_PATH || "/invite",
  TIMEOUT_MS: Number(process.env.REACT_APP_DEEPLINK_TIMEOUT_MS || 1500),
  IOS_APP_NUMERIC_ID: process.env.REACT_APP_IOS_APP_NUMERIC_ID || "",
  ANDROID_PACKAGE: process.env.REACT_APP_ANDROID_PACKAGE || "com.lengsup.app",
  STORE_URLS: {
    ios: (id) => (id ? `https://apps.apple.com/app/id${id}` : ""),
    android: (pkg) =>
      `https://play.google.com/store/apps/details?id=${
        pkg || "com.lengsup.app"
      }`,
  },
};
